var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 330.599,
    height: 316.03,
    viewBox: "0 0 330.599 316.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3eb2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59c0ea"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Success",
    transform: "translate(-51.777 -98.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--check-mark--inject-4",
    transform: "translate(81.128 98.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32091",
    "data-name": "Group 32091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13788",
    "data-name": "Path 13788",
    d: "M152.522,21.478h0l-.126-.063.454-.891L122.3,4.093h0l-.182-.087h0C108.058-3.1,89.3-.96,69.12,12.083,28.588,38.294-2.3,98.627.134,146.841c1.208,24.024,10.477,40.5,24.474,47.749h0l.118.063h0l30.1,17.329h0l.142.079h0c14.061,7.105,32.835,5,53.03-8.061,40.533-26.211,71.418-86.544,68.986-134.759C175.8,45.2,166.528,28.725,152.522,21.478Z",
    transform: "matrix(-0.454, -0.891, 0.891, -0.454, 80.418, 316.03)",
    fill: "#136189"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_692",
    "data-name": "Ellipse 692",
    cx: 107.5,
    cy: 62,
    rx: 107.5,
    ry: 62,
    transform: "translate(29.27 107.923)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--check-mark--inject-4-2",
    "data-name": "freepik--check-mark--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13749",
    "data-name": "Path 13749",
    d: "M385.875,97.215c-.316-.182-.647-.355-.979-.513a15.624,15.624,0,0,0-20.858,7.216L299.394,237.074l-3.679-3.947a15.181,15.181,0,0,0-3.663-2.929c-1.926-1.105-10.121-5.85-11.448-6.616a15.608,15.608,0,0,0-19.279,24.1l28.809,31.2a15.513,15.513,0,0,0,3.719,2.961c1.879,1.066,10.042,5.8,11.384,6.576a15.608,15.608,0,0,0,21.861-6.687l76.478-157.528a15.632,15.632,0,0,0-6.229-20.337Z",
    transform: "translate(-181.21 -95.135)",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13748",
    "data-name": "Path 13748",
    d: "M385.875,97.215c-.316-.182-.647-.355-.979-.513a15.624,15.624,0,0,0-20.858,7.216L299.394,237.074l-3.679-3.947a15.181,15.181,0,0,0-3.663-2.929c-1.926-1.105-10.121-5.85-11.448-6.616a15.608,15.608,0,0,0-19.279,24.1l28.809,31.2a15.513,15.513,0,0,0,3.719,2.961c1.879,1.066,10.042,5.8,11.384,6.576a15.608,15.608,0,0,0,21.861-6.687l76.478-157.528a15.632,15.632,0,0,0-6.229-20.337Z",
    transform: "translate(-181.21 -95.135)",
    fill: "#a8e7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13750",
    "data-name": "Path 13750",
    d: "M305.5,327.795c-1.326-.789-9.474-5.526-11.377-6.576a15.553,15.553,0,0,1-3.719-2.961l-28.809-31.2a15.553,15.553,0,0,1-2.976-4.737l11.456,6.608a15.166,15.166,0,0,0,2.992,4.737l28.8,31.2a15.877,15.877,0,0,0,3.632,2.929Z",
    transform: "translate(-181.513 -134.538)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13751",
    "data-name": "Path 13751",
    d: "M390.373,106.8a15.6,15.6,0,0,0-3.616,4.8L320.266,248.557l-9.616-10.421L375.294,104.98a15.41,15.41,0,0,1,3.624-4.8Z",
    transform: "translate(-192.466 -96.197)",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Check--inject-4",
    d: "M399.513,105.084a15.64,15.64,0,0,0-20.858,7.216L312.163,249.261l-13.287-14.4a15.6,15.6,0,0,0-22.9,21.174l28.8,31.209a15.608,15.608,0,0,0,25.5-3.774L406.76,125.942a15.624,15.624,0,0,0-7.248-20.858Z",
    transform: "translate(-184.363 -96.9)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-4",
    transform: "translate(51.777 112.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--like-icon--inject-4",
    transform: "translate(146.201 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13782",
    "data-name": "Path 13782",
    d: "M357.586,90.474l-4.429,1.334-3.2-10.682,4.413-1.326Z",
    transform: "translate(-349.96 -70.345)",
    fill: "#33d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13783",
    "data-name": "Path 13783",
    d: "M373,78.471a2.053,2.053,0,0,1-1.255,2.068,2.992,2.992,0,0,1,.624,1.129c.253.79-.418,1.934-1.753,2.368l-10.129,3.047-2.976-9.924h0s1.713-4.382,1.8-5.045-.924-3.095-1.066-3.553,1.5-1.058,2.795-.537a2.321,2.321,0,0,1,.789.576,7,7,0,0,1,1.161,1.666,5.945,5.945,0,0,1,.616,2.795l6.134-1.871a1.926,1.926,0,0,1,1.311,0,1.729,1.729,0,0,1,.489,2.921,1.634,1.634,0,0,1,1.674,1.129,1.8,1.8,0,0,1-1.011,2.045A1.9,1.9,0,0,1,373,78.471Z",
    transform: "translate(-351.549 -67.824)",
    fill: "#33d6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--like-icon--inject-4-2",
    "data-name": "freepik--like-icon--inject-4",
    transform: "translate(300.823 125.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13784",
    "data-name": "Path 13784",
    d: "M438.486,229.6l-5.676-1.366,3.308-13.69,5.676,1.366Z",
    transform: "translate(-432.81 -207.509)",
    fill: "#33d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13785",
    "data-name": "Path 13785",
    d: "M461.672,226.181a2.6,2.6,0,0,1-2.684,1.461,3.868,3.868,0,0,1-.039,1.626c-.253,1.066-1.7,1.847-3.4,1.429l-13-3.158,3.063-12.719h0s4.666-3.687,5.179-4.358.955-3.947,1.1-4.555,2.313-.2,3.395,1.2a2.882,2.882,0,0,1,.537,1.153,8.834,8.834,0,0,1,.205,2.55,7.619,7.619,0,0,1-1.105,3.45l7.848,1.895a2.424,2.424,0,0,1,1.405.876,2.266,2.266,0,0,1,.418,1.816,2.3,2.3,0,0,1-1.745,1.682,2.061,2.061,0,0,1,1.105,2.3,2.29,2.29,0,0,1-2.408,1.579,2.369,2.369,0,0,1,.126,1.776Z",
    transform: "translate(-434.86 -205.634)",
    fill: "#33d6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--like-icon--inject-4-3",
    "data-name": "freepik--like-icon--inject-4",
    transform: "translate(0 111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13786",
    "data-name": "Path 13786",
    d: "M76.82,219.253l6.2,1.863L87.5,206.163l-6.19-1.863Z",
    transform: "translate(-57.049 -190.974)",
    fill: "#33d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13787",
    "data-name": "Path 13787",
    d: "M52.182,202.413a2.874,2.874,0,0,0,1.761,2.9,4.3,4.3,0,0,0-.868,1.579c-.355,1.161.592,2.716,2.447,3.268l14.211,4.271,4.153-13.919h0s-2.408-6.142-2.526-7.105,1.3-4.326,1.492-4.974c.158-.521-2.1-1.476-3.947-.742a3.1,3.1,0,0,0-1.153.789,9.758,9.758,0,0,0-1.626,2.368,8.44,8.44,0,0,0-.868,3.947L56.73,192.22a2.669,2.669,0,0,0-1.84.063,2.416,2.416,0,0,0-.679,4.09,2.282,2.282,0,0,0-2.368,1.579,2.534,2.534,0,0,0,1.413,2.874A2.684,2.684,0,0,0,52.182,202.413Z",
    transform: "translate(-51.777 -187.421)",
    fill: "#33d6ff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.14dbdb8c1463e1ea2a00f52bcb625686.svg";
export { ForwardRef as ReactComponent };